import { HttpTransportType, HubConnectionBuilder } from "@microsoft/signalr";

export interface ChatMessage {
  Message: string;
  DiscussionId: number;
  DiscussionMemberId: number;
  Sent: boolean;
  UserId: string;
  Id: number;
  LastName: string;
  FirstName: string;
  CreationDate: Date;
}

class NotificationService {
  public onChatMessages: (
    onMessageReceived: (message: any) => void,
  ) => void;

  static instance: NotificationService;

  public connected: boolean = false;

  public connect(token: string) {
    const connection = new HubConnectionBuilder()
      .withUrl(`${process.env.REACT_APP_API_URL.trim()}/api/chat`, {
        accessTokenFactory: () => token,
        skipNegotiation: true,
        transport: HttpTransportType.WebSockets
      })
      .withAutomaticReconnect()
      .build();

    connection.start();
    this.connected = true;

    this.onChatMessages = (onMessageReceived) => {
      connection.on("NewMessage", (message) => {
        const m: ChatMessage = JSON.parse(message);
        onMessageReceived({
          message: m.Message,
          discussionId: m.DiscussionId,
          discussionMemberId: m.DiscussionMemberId,
          sent: m.Sent,
          userId: m.UserId,
          id: m.Id,
          lastName: m.LastName,
          firstName: m.FirstName,
          creationDate: m.CreationDate
        });
      });
    };
  }

  public static getInstance(): NotificationService {
    if (!NotificationService.instance) {
      NotificationService.instance = new NotificationService();
    }

    return NotificationService.instance;
  }
}

export default NotificationService.getInstance;
